import { MultiProfilePlanningTabs } from "@mcleod/dispatch/src/planning/MultiProfilePlanningTabs";
import { AutogenLayoutCollectionsMultiProfile } from "./autogen/AutogenLayoutCollectionsMultiProfile";
import { LMEUserSettings } from "@mcleod/general";
import { PanelProps } from "@mcleod/components";

export class CollectionsMultiProfile extends AutogenLayoutCollectionsMultiProfile {
    private userProfiles: string[] = [];

    override onLoad() {
        const userSettings = LMEUserSettings.get();
        if (userSettings?.collections_profile != null) {
            this.userProfiles.push(userSettings.collections_profile);
        }
        if (userSettings?.collections_profile2 != null) {
            this.userProfiles.push(userSettings.collections_profile2);
        }
        if (userSettings?.collections_profile3 != null) {
            this.userProfiles.push(userSettings.collections_profile3);
        }
        if (userSettings?.collections_profile4 != null) {
            this.userProfiles.push(userSettings.collections_profile4);
        }

        new MultiProfilePlanningTabs({
            tabset: this.tabsetCollectionsProfiles,
            profileDataSource: this.sourceCollectionsProfile,
            mainLayoutName: "lme/ar/Collections",
            advancedFilterLayout: "lme/ar/CollectionsProfileFilter",
            startingProfiles: this.userProfiles,
            profileDescrFieldName: "descr",
            refreshAfterTabChange: true
        });
    }

    // Override the main router's padding to get the vertical profile tabset to be flush with the edge of the screen
    getRouterProps(): Partial<PanelProps> {
        return { padding: 0 };
    }
}
